if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider     = this.querySelector('[data-js-slider]');
      this.content    = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index  = 0;
      this.length = this.content.length;

      // We loop, so no nav button is ever a dead end — clear the initial disabled state.
      if ( this.nextButton ) this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
      if ( this.prevButton ) this.prevButton.classList.remove('announcement-bar__content-nav--disabled');

      // Autoplay is driven by the section settings, passed down as data-attributes.
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.dataset.autoplay === 'true' && this.length > 1 && !this.reduceMotion;
      this.speed    = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this.timer    = null;

      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', () => { this.changeSlide('next'); this.restart(); });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', () => { this.changeSlide('prev'); this.restart(); });
      }

      if ( this.autoplay ) {
        // Pause while the visitor is reading or interacting, resume when they leave.
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin',    () => this.stop());
        this.addEventListener('focusout',   () => this.start());
        this.slider.addEventListener('touchstart', () => this.stop(), { passive: true });
        document.addEventListener('visibilitychange', () => {
          if ( document.hidden ) { this.stop(); } else { this.start(); }
        });
        this.start();
      }

    }

    changeSlide(direction) {

      if ( direction == 'next' ) {
        this.index = ( this.index + 1 ) % this.length;                 // wrap forward
      } else if ( direction == 'prev' ) {
        this.index = ( this.index - 1 + this.length ) % this.length;   // wrap back
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: this.reduceMotion ? 'auto' : 'smooth'
      });

    }

    start() {
      if ( !this.autoplay || this.timer ) return;
      this.timer = setInterval(() => this.changeSlide('next'), this.speed);
    }

    stop() {
      if ( this.timer ) { clearInterval(this.timer); this.timer = null; }
    }

    restart() {
      this.stop();
      this.start();
    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}
